import React from "react";

export default function End() {
  return (
    <>
      <h2 className="thank-you">Thank you for your challenge!</h2>
      <p>
        After successful completion of Mission 3, you will receive an email from
        us and you will be invited to an interview.
      </p>
      <h2 className="any-question-found-a-bug">Any question? Found a bug?</h2>
      <p>
        Please note that our team will not answer anything related to the
        challenge. If you have any (other) questions, please reach us through{" "}
        <a href="mailto:support@digitalproductschool.atlassian.net">
          <pre>
            <code>support@digitalproductschool.atlassian.net</code>
          </pre>
        </a>
      </p>
    </>
  );
}
